import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Compounds from "@/pages/Compounds";
import CompoundDetail from "@/pages/CompoundDetail";
import FormulaGenerator from "@/pages/FormulaGenerator";
import FormulaDetail from "@/pages/FormulaDetail";
import Formulas from "@/pages/Formulas";
import Portfolio from "@/pages/Portfolio";
import Treatments from "@/pages/Treatments";
import TreatmentDetail from "@/pages/TreatmentDetail";
import TreatmentForm from "@/pages/TreatmentForm";
import CorpusLog from "@/pages/CorpusLog";
import Patients from "@/pages/Patients";
import PatientDetail from "@/pages/PatientDetail";
import PatientForm from "@/pages/PatientForm";
import Account from "@/pages/Account";
import Schedules from "@/pages/Schedules";
import ScheduleBuilder from "@/pages/ScheduleBuilder";
import ScheduleDetail from "@/pages/ScheduleDetail";
import ProductAnalyzer from "@/pages/ProductAnalyzer";
import CompoundForm from "@/pages/CompoundForm";
import CorpusEventDetail from "@/pages/CorpusEventDetail";
import FormulasTrash from "@/pages/FormulasTrash";

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="bottom-right" richColors closeButton />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                        <Route index element={<Dashboard />} />
                        <Route path="compuestos" element={<Compounds />} />
                        <Route path="compuestos/nuevo" element={<CompoundForm />} />
                        <Route path="compuestos/:slug" element={<CompoundDetail />} />
                        <Route path="compuestos/:slug/editar" element={<CompoundForm />} />
                        <Route path="formulas" element={<Formulas />} />
                        <Route path="formulas/nuevo" element={<FormulaGenerator />} />
                        <Route path="formulas/papelera" element={<FormulasTrash />} />
                        <Route path="formulas/:id" element={<FormulaDetail />} />
                        <Route path="portfolio" element={<Portfolio />} />
                        <Route path="tratamientos" element={<Treatments />} />
                        <Route path="tratamientos/nuevo" element={<TreatmentForm />} />
                        <Route path="tratamientos/:slug" element={<TreatmentDetail />} />
                        <Route path="tratamientos/:slug/editar" element={<TreatmentForm />} />
                        <Route path="pacientes" element={<Patients />} />
                        <Route path="pacientes/nuevo" element={<PatientForm />} />
                        <Route path="pacientes/:id" element={<PatientDetail />} />
                        <Route path="pacientes/:id/editar" element={<PatientForm />} />
                        <Route path="cronogramas" element={<Schedules />} />
                        <Route path="cronogramas/nuevo" element={<ScheduleBuilder />} />
                        <Route path="cronogramas/:id" element={<ScheduleDetail />} />
                        <Route path="analizador" element={<ProductAnalyzer />} />
                        <Route path="cuenta" element={<Account />} />
                        <Route path="corpus" element={<CorpusLog />} />
                        <Route path="corpus/:id" element={<CorpusEventDetail />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
